<template>
  <div :class="props.class" :style="props.style" v-bind="props.attrs">
    
    <el-tabs v-model="state.activeName" stretch class="many-goods-tab">
      <el-tab-pane 
        v-for="(setting, idx) in prepare.settings" 
        :key="idx" 
        :name="idx"
        >
        <template #label>
          <div :title="setting.navTitle" :class="state.activeName == idx ? 'active' : ''" class="mb-2">
            <div v-if="setting?.dataCategoryName" class="many-goods-group-category-name">
              {{ setting?.dataCategoryName }}
            </div>
            
            <small v-if="setting?.dataSubtitle" class="many-goods-group-subtitle">
              {{ setting?.dataSubtitle }}
            </small>
          </div>
        </template>
        <keep-alive>
          <ManyGoodsItemElement 
            v-if="state.activeName === idx"
            :setting="setting" 
            @choose:assort="onProductChooseAssort" 
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <div class="sample">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, ref, toRaw, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n"
import { cloneDeep } from "lodash"
// import {} from "../../../api/index.js";
// import _ from "lodash";
import {
  notificationErrors,
  currencyFormat,
  assignCartCount,
  clearCartCount,
  dataTranslations,
  breakpoint,
  lookupAliasTranslations,
  dashToHump,
} from "../../../utils";
import { renderHtml, getOptionsFromNode } from "../../../plugins/html-to-vue/index.js";
import ManyGoodsItemElement from "./ManyGoodsItemElement.vue"

const props = defineProps({
  data: String,
  class: String,
  style: String,
  attrs: Object,
})

const emit = defineEmits(["update:cart", "choose:assort"]);

const { t, locale } = useI18n()

const store = useStore();

const storeData = computed(() => store.getters["lite/storeData"]);
const loginUserId = computed(() => store.getters["lite/userData"]?.id);
const cartData = computed(() => store.getters["lite/cartData"]);
const cartCount = computed(() => store.getters['lite/cartCount']);
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart)
const currency = computed(() => aibTrackers?.currency)

const state = reactive({
  activeName: 0,
})
const elemObj = ref(null)

const prepare = computed(() => {
  const dataSets = {}
  
  for (let value in props.attrs) {
    if (["style", "class"].includes(value)) {
      continue
    }
    const textArr = dashToHump(value);
    dataSets[textArr] = aibTrackers.isNumber(props.attrs[value]) ? Number(props.attrs[value]) : props.attrs[value]
  }
  // console.debug("dataSets", dataSets)

  dataSets['settings'] = []
  if (elemObj.value) {
    const items = elemObj.value.find('.many-goods-item');
    const itemTemplate = elemObj.value.find('.goods-item').first();
    if (items.length) {
      items.each((idx, item) => {
        const attrs = getOptionsFromNode(item)
        if (!!attrs['style']) {
          delete attrs['style']
        }
        
        let itemSets = {
          selector: () => $(item),
          template: () => itemTemplate.clone(true),
          // template: () => cloneDeep(itemTemplate),
          navTitle: "多商品組",
          quantity: dataSets['dataQuantity'],
          theme: dataSets['dataTheme'],
          listClass: `${dataSets['dataTheme']} ${dataSets['dataTheme']}_${dataSets['dataStyle']} goods-list`,
          hasPage: 1,
          attrs,
          // limit: dataSets['dataQuantity'] > 12 ? 12 : dataSets['dataQuantity'],
        }
        
        for (let value in attrs) {
          const textArr = dashToHump(value);
          itemSets[textArr] = aibTrackers.isNumber(attrs[value]) ? Number(attrs[value]) : attrs[value]
          
          if (["dataSourceCategoryIds", "dataSourceManualIds", "dataSourceAssortIds"].includes(textArr)) {
            if (itemSets[textArr] == 0) {
              itemSets[textArr] = null
            }
          }
        }
        
        if (itemSets.dataCategoryName || itemSets.dataSubtitle) {
          itemSets.navTitle = `${itemSets.dataCategoryName}`
          if (itemSets.dataSubtitle) {
            itemSets.navTitle += `-${itemSets.dataSubtitle}`
          }
        }
        
        if (!itemSets["dataSourceCategoryIds"] && !itemSets["dataSourceManualIds"]) {
          itemSets.hasPage = 0
        }
        if (itemSets["dataSource"] == "category") {
          itemSets["dataSourceManualIds"] = null
          itemSets["dataSourceAssortIds"] = null
        } else if (itemSets["dataSource"] == "manual") {
          itemSets["dataSourceCategoryIds"] = null
        }
        const params = {
          status: "shelves",
          fields: "price_range,assort_count,assorts,assorts.image_url",
          is_hidden: 0,
          limit: 12,
          store_id: dataSets.dataStoreId,
          currency: dataSets.dataCurrency,
          lang: dataSets.dataLang,
          sort: dataSets.dataSort,
          store_cat_id: itemSets.dataSourceCategoryIds,
          ids: itemSets.dataSourceManualIds,
          page: itemSets.hasPage,
        };
        itemSets['params'] = params

        dataSets['settings'].push(itemSets)
        // console.debug("itemSets", itemSets)
      })
      elemObj.value.find('ul.nav').remove()
      // elemObj.value.find('.many-goods-item').hide()
    }
  }
  // console.debug("items", toRaw(dataSets['items']))
  
  return dataSets
})

const updateCart = () => {
  // 重抓購物車
  emit("update:cart")
}

const onProductChooseAssort = (id) => {
  // dataButtonAction
  if (prepare.value?.dataButtonAction == "page") {
    store.dispatch("lite/setFullPageLoading", true);
    window.location.assign(`/products/${id}`);
    store.dispatch("lite/setFullPageLoading", false);
  } else {
    // 開啟選擇規格視窗
    emit("choose:assort", id)
  }
}

onMounted(() => {
  if (typeof prepare.value.id !== 'undefined') {
    elemObj.value = $("#"+prepare.value.id);
    // console.debug("prepare.id", prepare.value.id, elemObj.value)
    // 隱藏html, 改用vue元件取代
    // elemObj.value.find('.login-register-block').attr('style', 'display: none !important;')
    
    elemObj.value.find('.hide-nav').remove()
  }
  // console.debug("prepare", prepare.value)
})
</script>

<style lang="scss">
  .many-goods-tab .el-tabs__item {
    height: auto !important;
    line-height: 1.7;
  }
  .many-goods-tab .el-tabs__nav-wrap::after, .many-goods-tab .el-tabs__active-bar {
    background-color: #ffffff;
  }
</style>